import React from 'react'
import OwlCarousel from 'react-owl-carousel';
import ObjCarruselUp from './ObjCarruselUp';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import optionsCarruselUp from './OptionsCarruselUp';

export const CarruselBoxUp = () => {

  return (
    <OwlCarousel className='owl-theme' loop nav stagePadding autoplay margin={10} {...optionsCarruselUp}>
        {ObjCarruselUp.map((id) => (
            <section className="carrusel-up-mobile">
              <div className="carrusel-up__content-mobile">
                {
                  <div className="item-box">
                    <div className="image-box" id={id.class}>
                      <div className="btn-black left">
                        <a href={id.url1} target='_parent'>{id.button1}</a>
                      </div>
                      <div className="btn-black right">
                        <a href={id.url2} target='_parent'>{id.button2}</a>
                      </div>
                    </div>
                    <article className="txt">
                      <h2>{id.nameh1}</h2>
                      <p>{id.namep}</p>
                    </article>
                  </div>
                }
              </div>
            </section>
        ))}
    </OwlCarousel>
  )
}

export default CarruselBoxUp